export default [
  {
    path: '/user',
    component: () => import('@/views/pages/user/index'),
    redirect: '/user/:userID/main',
    children: [
      {
        path: '/user/:userID',
        name: 'main',
        meta: { title: "个人中心" },
        component: () => import('@/views/pages/user/main.vue')
      },
      {
        path: '/user/:userID/main',
        name: 'main',
        meta: { title: "个人中心" },
        component: () => import('@/views/pages/user/main.vue')
      },
      {
        path: '/user/:userID/practice',
        name: 'practice',
        meta: { title: "个人中心" },
        component: () => import('@/views/pages/user/practice.vue')
      },
      {
        path: '/user/:userID/ask',
        name: 'ask',
        meta: { title: "个人中心" },
        component: () => import('@/views/pages/user/Ask.vue')
      },
      {
        path: '/user/:userID/att',
        name: 'att',
        meta: { title: "个人中心" },
        component: () => import('@/views/pages/user/Att.vue')
      },
      {
        path: '/user/:userID/bbs',
        name: 'bbs',
        meta: { title: "个人中心" },
        component: () => import('@/views/pages/user/Bbs.vue')
      },
      {
        path: '/user/:userID/blog',
        name: 'blog',
        meta: { title: "个人中心" },
        component: () => import('@/views/pages/user/Blog.vue')
      },
      {
        path: '/user/:userID/doc',
        name: 'doc',
        meta: { title: "个人中心" },
        component: () => import('@/views/pages/user/Doc.vue')
      },
      {
        path: '/user/:userID/fans',
        name: 'fans',
        meta: { title: "个人中心" },
        component: () => import('@/views/pages/user/Fans.vue')
      },
    ]
  }
]
